export enum EProjectStatus {
  COMPLETED = 'completed',
  ONGOING = 'ongoing',
  CANCELED = 'canceled',
}
